module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "editor"
    }
  }, [_c('nav', [_c('ol', _vm._l((_vm.resume.config), function(item, index) {
    return _c('li', {
      class: {
        active: item.field === _vm.selected
      },
      on: {
        "click": function($event) {
          _vm.selected = item.field
        }
      }
    }, [_c('svg', {
      staticClass: "icon"
    }, [_c('use', {
      attrs: {
        "xlink:href": ("#icon-" + (item.icon))
      }
    })])])
  }), 0)]), _vm._v(" "), _c('ol', {
    staticClass: "panels"
  }, _vm._l((_vm.resume.config), function(item) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.field === _vm.selected),
        expression: "item.field === selected"
      }]
    }, [_c('h2', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (_vm.resume[item.field] instanceof Array) ? _c('div', [_vm._l((_vm.resume[item.field]), function(subitem, i) {
      return _c('div', {
        staticClass: "subitem"
      }, [_c('i', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.resume[item.field].length > 1),
          expression: "resume[item.field].length > 1"
        }],
        staticClass: "el-icon-circle-close close-item",
        on: {
          "click": function($event) {
            return _vm.removeItem(("" + (item.field)), i)
          }
        }
      }), _vm._v(" "), _vm._l((subitem), function(value, key) {
        return (key !== 'title') ? _c('div', {
          staticClass: "resumeField"
        }, [_c('p', {}, [_vm._v(" " + _vm._s(key) + " ")]), _vm._v(" "), _c('div', {
          staticClass: "field"
        }, [_c('div', {
          staticClass: "control"
        }, [_c('input', {
          staticClass: "input text",
          attrs: {
            "type": "text",
            "placeholder": "input"
          },
          domProps: {
            "value": value
          },
          on: {
            "input": function($event) {
              return _vm.changeResumeField(((item.field) + "." + i + "." + key), $event.target.value)
            }
          }
        })])])]) : _vm._e()
      }), _vm._v(" "), _c('hr')], 2)
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.addItem(("" + (item.field)))
        }
      }
    }, [_vm._v("添加一项")])], 2) : _vm._l((_vm.resume[item.field]), function(value, key) {
      return _c('div', {
        staticClass: "resumeField"
      }, [_c('p', {}, [_vm._v(" " + _vm._s(key) + " ")]), _vm._v(" "), _c('div', {
        staticClass: "field"
      }, [_c('div', {
        staticClass: "control"
      }, [_c('input', {
        staticClass: "input text",
        attrs: {
          "type": "text",
          "placeholder": "input"
        },
        domProps: {
          "value": value
        },
        on: {
          "input": function($event) {
            return _vm.changeResumeField(((item.field) + "." + key), $event.target.value)
          }
        }
      })])])])
    })], 2)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34a3a16c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor.vue
// module id = 189
// module chunks = 1